<mat-card class="video-card" [routerLink]="['/models', video.userId]">
  <div class="video-container">
    <video [src]="video.firebaseUrl" preload="metadata"></video>
    <div class="play-overlay">
      <mat-icon class="play-icon">play_circle_filled</mat-icon>
    </div>
  </div>
  <mat-card-content>
    <p class="video-description" *ngIf="video.description">{{ video.description }}</p>
    <p class="video-model" *ngIf="modelName">{{ modelName }}</p>
    <div class="video-stats">
      <span><mat-icon>favorite</mat-icon> {{ video.likesCount }}</span>
      <span><mat-icon>visibility</mat-icon> {{ video.viewsCount }}</span>
    </div>
  </mat-card-content>
</mat-card>
